import {useMutation} from "@apollo/client";

import {ActionDialog} from "@/components/overlay/ActionDialog.tsx";
import {GQL_CHECKS_QUERY2, GQL_DELETE_CHECKS} from "@/lib/queries/checks.ts";
import {GraphQLResponse, ResponseStatus} from "@/lib/types/common.ts";

export interface BulkDeleteChecksModalProps {
  selectedItemsIds: number[];
  show: boolean;
  setShow: (show: boolean) => void;
  onSuccess: () => void;
}

export const BulkDeleteChecksModal = ({selectedItemsIds, show, setShow, onSuccess}: BulkDeleteChecksModalProps) => {
  const [deleteChecks, {loading}] = useMutation<GraphQLResponse<null>>(GQL_DELETE_CHECKS, {
    refetchQueries: [GQL_CHECKS_QUERY2],
  });

  const handleSubmit = async () => {
    const response = await deleteChecks({
      variables: {
        ids: selectedItemsIds,
      },
    });
    if (response.data?.response.status === ResponseStatus.SUCCESS) {
      setShow(false);
      onSuccess();
    }
  };

  return (
    <ActionDialog
      show={show}
      loading={loading}
      title={"Delete Multiple Checks"}
      onConfirm={handleSubmit}
      onCancel={() => setShow(false)}
    >
      <div>
        <div className="row mb-4">
          <div className="col">
            Are you sure you want to delete {selectedItemsIds.length} Checks? Checks and associated Alerts will be
            permanently deleted and non-recoverable after 30 days.
          </div>
        </div>
        <div className="row mb-4">
          <div className="col">
            <b>Note:</b> Deleting a group Check will neither delete its nested Checks nor any Alerts associated with
            those.
          </div>
        </div>
      </div>
    </ActionDialog>
  );
};
